<div class="lookup-user-detail p-4">
  <section class="card mb-4" role="region" aria-labelledby="lookup-user-profile-heading">
    <div class="card-head d-flex justify-content-between align-items-center flex-wrap gap-2">
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <button type="button" class="profile-card-close-btn" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span> Close
        </button>
      </div>
      <button class="inbox-btn" aria-label="Open Message Inbox" (click)="navigateToMessageInbox()" type="button">
        Message Inbox
      </button>
    </div>
    <hr class="full-width-line" role="presentation" aria-hidden="true" />
    <div class="card-body-profile">
      <div class="row" role="presentation">
        <div class="col-12 col-sm-6 col-md-3 mb-4">
          <label class="label" id="lookup-name-label">Name on Record</label>
          <div class="value" aria-labelledby="lookup-name-label">{{ nameOnRecord }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label" id="lookup-license-num-label">License Number</label>
          <div class="value" aria-labelledby="lookup-license-num-label">{{ licenseNumber }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label" id="lookup-license-status-label">License Status</label>
          <div
            class="value"
            [ngClass]="{ 'text-success': licenseStatus !== overviewEnDash && licenseStatus !== 'Inactive' ,
            'inactive-class': licenseStatus === 'Inactive'
            }"
            aria-labelledby="lookup-license-status-label">
            {{ licenseStatus }}
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label" id="lookup-license-exp-label">License Expiration Date</label>
          <div class="value" aria-labelledby="lookup-license-exp-label">{{ licenseExpiration }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label">Application Status</label>
          <div class="value">{{ applicationStatus }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label">Application ID</label>
          <div class="value">{{ applicationId }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label">Application Type</label>
          <div class="value">{{ applicationType }}</div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label class="label">License Path</label>
          <div class="value">{{ licensePath }}</div>
        </div>
      </div>
    </div>
  </section>

  <app-tabs
    [tabs]="tabs"
    [activeTab]="activeTab"
    [tabIdPrefix]="'lookup-user'"
    [containerClass]="'my-applications-container'"
    (tabSelected)="onTabSelected($event)">

    <lookup-user-personal-tab
      *ngIf="activeTab === 'personal'"
      [personId]="personId"
      [row]="educatorDashboardRow"
      (requestDashboardRefresh)="refreshEducatorDashboard()"
      (openApplicationLicenseTab)="onOpenApplicationLicenseTab($event)">
    </lookup-user-personal-tab>

    <lookup-user-activities-tab
      *ngIf="activeTab === 'activities'"
      [personId]="personId"
      [row]="educatorDashboardRow"
      (requestDashboardRefresh)="refreshEducatorDashboard()">
    </lookup-user-activities-tab>
    <lookup-user-license-tab *ngIf="activeTab === 'license'" [personId]="personId" [row]="educatorDashboardRow"(requestDashboardRefresh)="refreshEducatorDashboard()" (licenseStatusChanged)="onLicenseStatusChanged($event)">
    </lookup-user-license-tab>
    <lookup-user-placeholder-tab *ngIf="activeTab === ''" [tabKey]="'Experience'"></lookup-user-placeholder-tab>
    <lookup-user-experience-tab *ngIf="activeTab === 'experience'" [personId]="personId" [educatorDashboardRow]="educatorDashboardRow" (requestDashboardRefresh)="refreshEducatorDashboard()"></lookup-user-experience-tab>
    <lookup-user-communication-tab
      *ngIf="activeTab === 'communication'"
       [personId]="personId"
      [applicationId]="applicationId"
      [educatorDashboardRow]="educatorDashboardRow"
      (refreshed)="onSectionRefresh($event)"
      [communicationsData]="educatorDashboardRow?.p_communications">
    </lookup-user-communication-tab>
    <lookup-user-education-tab [educatorDashboardRow]="educatorDashboardRow" [personId]="personId" *ngIf="activeTab === 'education'" [tabKey]="'Education'" (refreshed)="onSectionRefresh($event)"></lookup-user-education-tab>
    <lookup-user-placeholder-tab *ngIf="activeTab === 'communication'" [tabKey]="'Communication'"></lookup-user-placeholder-tab>

    <lookup-user-logs-tab *ngIf="activeTab === 'logs'" [auditGridData]="educatorDashboardRow?.p_audit"></lookup-user-logs-tab>

    <lookup-user-legacy-data-tab *ngIf="activeTab === 'legacyData'"></lookup-user-legacy-data-tab>
  </app-tabs>
</div>
